import { comingSoonProducts } from "constant/commonConstant";
import { getRegion } from "./utils";

export function productUrlHelper(product: string): string {
  switch (getRegion()) {
    case "asia":
      return process.env[`REACT_APP_${product}_URL_ASIA`] ?? "";
    case "us":
      return process.env[`REACT_APP_${product}_URL_US`] ?? "";
    default:
      return process.env[`REACT_APP_${product}_URL_ASIA`] ?? "";
  }
}

export function isComingSoonProducts(product: string): boolean {
  return comingSoonProducts.includes(product.toUpperCase());
}
